export const UPDATE_DATA_ON_COVER_CHANGE = "UPDATE_DATA_ON_COVER_CHANGE";
export const SET_DATA_ON_INTERVIEW_OUTCOME = "SET_DATA_ON_INTERVIEW_OUTCOME";
export const SET_IS_UPDATING = "SET_IS_UPDATING";
